import React from 'react';
import Preview from './preview.svg';

const TypingTest = () => <img src={Preview} alt="preview" />;

export default TypingTest;
